export enum Authority {
  GESTIONNAIRE = 'ROLE_GESTIONAIRE'
}
